import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { dataActions } from "../../store/data-slice";
import { stepperActions } from "../../store/stepper-slice";
import { toggleActions } from "../../store/toggle-slice";
import { screenActions } from "../../store/screens-slice";

import Stepper from "../../ui/Stepper";

import Reserva from "../../components/Reserva/Reserva";

import "./Resumen.css";
import "../../components/Reserva/Reserva.css";
import "../../components/Element/Element.css";

import PopPop from "react-poppop";

import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { containerVariants } from "../../animations/transitions";
import {
  formatCertificatesListLink,
  formatShipmentDataLink,
  getExtraPracticeCodes,
  getInputNameList,
} from "../../helpers/formatExtrasLink";
import {
  concatArrayOfElementsWithComma,
  concatWithComma,
} from "../../helpers/concatWithComma";
import { COURSE_CODES } from "../../constans/courseCodes";

const Resumen = () => {
  const [t, i18n] = useTranslation("global");
  const { language } = i18n;
  const domain = "https://tienda.escolaport.com";
  let page = "carrito";
  const [redirectLink, setRedirectLink] = useState("");
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();

  const practicesData = useSelector((state) => state.data.practicas);
  const theory = useSelector((state) => state.data.teoria);
  const theoryModality = useSelector((state) => state.data.tipoTeoria);
  const modality = theoryModality === "Presencial" ? "presential" : "streaming";
  const extras = useSelector((state) => state.data.extras);
  const practicesEnrollmentCount = useSelector(
    (state) => state.data.practicas.personas
  );

  const extrasInputListMedicCertificate = useSelector(
    (state) => state.data.extrasInputListCM
  );
  const extrasInputListExpressDelivery = useSelector(
    (state) => state.data.extrasInputListEE
  );
  const extrasInputListMailDeliveryCode = useSelector(
    (state) => state.data.extrasInputListEC
  );

  const toggleShow = (show) => {
    setshow(show);
  };

  const handleNextScreen = () => {
    //! Add-to-cart Codes

    let practicesPackCode;
    if (practicesData.periodo === "entre_semana") {
      practicesPackCode = concatWithComma(
        COURSE_CODES.LN_PRACTICA_TEORIA_ENTRE_SEMANA_PACK,
        practicesData.personas
      );
    } else {
      practicesPackCode = concatWithComma(
        COURSE_CODES.LN_PRACTICA_TEORIA_FIN_SEMANA_PACK,
        practicesData.personas
      );
    }

    let addToCartCode = practicesPackCode;
    const extrasCodes = getExtraPracticeCodes(extras);

    if (extrasCodes) {
      addToCartCode += `,${extrasCodes}`;
    }

    //! Fecha de Teoria
    let theoryIdQuery;

    if (theory.data.message) {
      theoryIdQuery = "&fecha_teoria_ln=default";
    } else {
      theoryIdQuery = `&fecha_teoria_ln=${theory.data.id}`;
    }

    //! Fecha de Prácticas
    const periodo =
      practicesData.periodo === "fin_semana" ? "fin_de_semana" : "entre_semana";
    const practica = practicesData.data.message
      ? "default"
      : practicesData.data.id;

    const practiceIdQuery = `&fecha_practica_ln_${periodo}=${practica}`;

    //! CM NAMES - Link
    let namesListCM = getInputNameList(
      "nombres_cm",
      extrasInputListMedicCertificate,
      practicesEnrollmentCount
    );

    //! EE NAMES - Link
    let namesListEE = getInputNameList(
      "nombres_ee",
      extrasInputListExpressDelivery,
      practicesEnrollmentCount
    );

    //! EC NAMES - Link
    let certificatesListLink = formatCertificatesListLink(
      extrasInputListMailDeliveryCode
    );
    let shipmentDataLink = formatShipmentDataLink(
      extrasInputListMailDeliveryCode
    );
    let namesListEC = extrasInputListMailDeliveryCode.length
      ? `&${shipmentDataLink}&${certificatesListLink}`
      : "";

    const extrasQuery = `${namesListCM}${namesListEE}${namesListEC}`;

    //! Modality
    let modalityQuery = `&modalidad=${modality}`;

    let completeLinkWithParams = `${domain}/${page}/?add-to-cart=${addToCartCode}${practiceIdQuery}${theoryIdQuery}${extrasQuery}${modalityQuery}`;
    console.log(completeLinkWithParams);

    toggleShow(true);
    setRedirectLink(completeLinkWithParams);
  };

  const handleNavigateBackScreen = () => {
    dispatch(toggleActions.disableClass(false));
    dispatch(screenActions.setMainScreen("extras"));
    dispatch(stepperActions.setActiveStep(2));
  };

  const handleDelete = () => {
    dispatch(
      dataActions.applyPracticas({
        personas: 1,
        periodo: "entre_semana",
        data: {},
      })
    );
    dispatch(
      dataActions.applyTeoria({
        personas: 1,
        data: {},
      })
    );
    dispatch(dataActions.applyExtras([]));
    dispatch(dataActions.setResetExtrasState());
    dispatch(dataActions.setTipoTeoria("Presencial"));
    dispatch(dataActions.elementoSeleccionadoEnPracticas(""));
    dispatch(dataActions.elementoSeleccionadoEnTeoria(""));
    dispatch(toggleActions.disableClass(false));
    dispatch(stepperActions.setActiveStep(0));
    dispatch(screenActions.setMainScreen("practicas"));
    dispatch(screenActions.setScrollDivPracticas(""));
    dispatch(screenActions.setScrollDivTeoria(""));
    window.scrollTo(0, 0);
  };

  const Popup = () => {
    return (
      <div>
        <PopPop
          position="centerCenter"
          open={show}
          closeBtn={true}
          closeOnEsc={true}
          onClose={() => toggleShow(false)}
          closeOnOverlay={true}
          contentStyle={{
            backgroundColor: "#E1E1E1",
            overflow: "hidden",
            padding: 20,
          }}
        >
          <div>
            <div className="resumen__logoContainer">
              <img
                src="https://escolaportbarcelona.com/wp-content/uploads/2018/06/Simbolo-Escola-Port.png"
                logo="logo_escolaport"
              />
            </div>
            <p className="resumen__popupParag">{t("RESUMEN.popup.desc")}</p>
            <a
              className="resumen__popupButton"
              href={redirectLink}
              target="_blank"
              onClick={() => {
                toggleShow(false);
              }}
            >
              {t("RESUMEN.popup.continue")}
            </a>
          </div>
        </PopPop>
      </div>
    );
  };

  let teoria_t;

  if (language == "en") {
    if (theoryModality == "Presencial") {
      teoria_t = `${t("RESUMEN.theory.type.presential")} ${t(
        "RESUMEN.theory.name"
      )}`;
    } else {
      teoria_t = `${t("RESUMEN.theory.type.streaming")} ${t(
        "RESUMEN.theory.name"
      )}`;
    }
  } else {
    if (theoryModality == "Presencial") {
      teoria_t = `${t("RESUMEN.theory.name")} ${t(
        "RESUMEN.theory.type.presential"
      )}`;
    } else {
      teoria_t = `${t("RESUMEN.theory.name")} ${t(
        "RESUMEN.theory.type.streaming"
      )}`;
    }
  }

  return (
    <div>
      <Stepper />
      <motion.div
        className="resumen__container"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <h3 className="resumen__resumen-title">{t("RESUMEN.sub_title")}</h3>
        <h2>{t("RESUMEN.title")}</h2>

        <Reserva
          data={practicesData.data}
          personas={practicesData.personas}
          title={`${t("RESUMEN.practice")} 4h`}
        />

        <Reserva
          data={theory.data}
          personas={practicesData.personas}
          tipo="teoria"
          title={`${teoria_t} 2h`}
        />

        <>
          {extras.map((el, idx) =>
            el.id === "EC" ? (
              <Reserva
                key={el.id}
                data={el.data}
                personas={extras.find((e) => e.id === "EC").courseQuantity}
                ECData={extrasInputListMailDeliveryCode}
                tipo="extras"
                title={`${el.title} x ${extrasInputListMailDeliveryCode.length}`}
              />
            ) : (
              <Reserva
                key={el.id}
                title={el.title}
                price={el.price}
                CM_or_EEData={
                  el.id === "CM"
                    ? extrasInputListMedicCertificate
                    : extrasInputListExpressDelivery
                }
                personas={el.courseQuantity}
              />
            )
          )}
        </>

        <Popup />

        <div className="element__bottom curso__bottom">
          <div className="element__buttonsContainer">
            <div className="element__volverContainer">
              <button onClick={handleNavigateBackScreen}>
                {t("ELEMENT.button.back")}
              </button>
            </div>

            <div className="element__continueContainer">
              <button onClick={handleNextScreen}>
                {t("ELEMENT.button.next")}
              </button>
            </div>
          </div>
        </div>

        <div className="element__borrarContainer">
          <button onClick={handleDelete}>{t("RESUMEN.button.delete")}</button>
        </div>
      </motion.div>
    </div>
  );
};

export default Resumen;
